import { useApolloClient } from "@apollo/client"

import { useEvent } from "shared/lib/useEvent"

import { readTeamMember } from "../lib/readTeamMember"

export function useGetTeamMember() {
  const { cache } = useApolloClient()
  return useEvent((id: string) => {
    return readTeamMember(id, cache)
  })
}
